import * as Yup from 'yup';
import { AddressValidationHelper } from '../../../shared/helpers/address-validation.helper';

export const CreatePropertyValidationSchema: Yup.ObjectSchema = Yup.object().shape({
    address: Yup.string()
        .nullable()
        .test('address', 'Die eingegeben Adresse ist nicht valide.', (value) => AddressValidationHelper.isValid(value))
        .required('Dies ist ein Pflichtfeld.')
})
